export enum ItemCondition {
  BROKEN = 'BROKEN',
  CRUSHED = 'CRUSHED',
  FROZEN = 'FROZEN',
  LEAKING = 'LEAKING',
  STAINED = 'STAINED',
  THAWED = 'THAWED',
  TORN = 'TORN',
  WARM = 'WARM',
  WET = 'WET',
  DAMAGED_LABEL = 'DAMAGED_LABEL',
  CUT = 'CUT',
}
